/**
 * Deploy-specific configuration constants.
 */
export const IFRAME_EMBED_ALLOWED_LOCATIONS = [
    'work-alpha.8x8.com',
    'work.8x8.com'
];
